import { render, staticRenderFns } from "./cancelOrderList.vue?vue&type=template&id=ab2978be&scoped=true&"
import script from "./cancelOrderList.vue?vue&type=script&lang=js&"
export * from "./cancelOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab2978be",
  null
  
)

export default component.exports